<template>
    <div class="r_articles_row">
        <nuxt-link :to="`/articles/${article.slug}`" class="r_article flex">
            <div class="top_section">
                <div class="top_section_inner">
                    <div class="course_name">
                        {{ article.name }}
                    </div>

                    <div class="article_categories">
                        <div class="tags_list flex">
                            <div
                                v-for="tag in article.tags"
                                :key="tag.id"
                                class="tag"
                            >
                                <span class="active">
                                    {{ tag.name }}
                                </span>
                            </div>

                            <div v-if="article.category" class="tag">
                                <span>
                                    {{ article.category.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bottom_section">
                <div class="image_thumbnail">
                    <div
                        v-full-background-image-path="article.featuredImage"
                        class="image bg_image cover"
                    />
                </div>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
export default {
    props: {
        article: {
            type: Object,
            required: true
        }
    }
};
</script>
